export default "__VITE_ASSET__BM0gF644__"